export default "__VITE_ASSET__BEVjwGjh__"